import { createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../../constants/enum";
import { fetchAutomationAsync, fetchWorkflowListAsync, upsertActionNode, upsertContitionNode, upsertFinishEmailActionNode, upsertWorkflow } from "./automation.actions";
import { updateNodesWithPlaceholderAndEdges } from "./automation.helpers";
import { initialAutomationState } from "./automation.state";
import { getUniqueId } from "../../helpers";

const automationSlice = createSlice({
    initialState: initialAutomationState,
    name: "automation",
    reducers: {
        addPlaceholderNode: (state) => {
            const nodes: any = [
                {
                    id: getUniqueId(),
                    data: { label: "+", payload: {} as any },
                    position: { x: 0, y: 0 },
                    type: "placeholder",
                },
            ];
            const edges: any = [];

            for (let i = 0; i < nodes.length; i++) {
                if (i !== 0) {
                    const targetId = nodes[i].id;
                    const sourceId = nodes[i - 1].id;
                    edges.push({
                        id: sourceId + "=>" + targetId,
                        source: sourceId,
                        target: targetId,
                        type: nodes[i].type,
                    });
                }
            }
            state.graphLoadState = LoadState.succeeded;
            state.graphData = {
                edges: edges,
                nodes: nodes,
                workflow_basic_code: "",
            };
        },
        clearAutomationState: (state) => {
            return initialAutomationState
        }
    },
    extraReducers: (builder) => {
        //#################################### fetchWorkflowListAsync ##############################################
        builder.addCase(fetchWorkflowListAsync.pending, (state, action) => {
            state.loading = LoadState.pending
        })
        builder.addCase(fetchWorkflowListAsync.fulfilled, (state, action) => {
            state.loading = LoadState.succeeded
            state.list = action.payload.data
            state.totalRecords = action.payload.count
        })
        builder.addCase(fetchWorkflowListAsync.rejected, (state, action) => {
            state.loading = LoadState.failed;
            state.list = []
        })


        //#################################### fetchAutomationAsync ##############################################
        builder.addCase(fetchAutomationAsync.pending, (state, action) => {
            state.graphLoadState = LoadState.pending
        })
        builder.addCase(fetchAutomationAsync.fulfilled, (state, action) => {
            state.graphLoadState = LoadState.succeeded
            state.graphData = action.payload
            return state
        })
        builder.addCase(fetchAutomationAsync.rejected, (state, action) => {
            state.graphLoadState = LoadState.failed;
            state.graphData = {
                nodes: [],
                edges: [],
                workflow_basic_code: null,
            };
        })

        //#################################### upsertWorkflow ##############################################
        builder.addCase(upsertWorkflow.fulfilled, (state, action) => {
            const node = action.payload;
            state = updateNodesWithPlaceholderAndEdges(state, node, false)
            return state
        })


        //#################################### upsertContitionNode ##############################################
        builder.addCase(upsertContitionNode.fulfilled, (state, action) => {
            const { node, isDelete } = action.payload;
            state = updateNodesWithPlaceholderAndEdges(state, node, isDelete)
            return state
        })

        //#################################### upsertActionNode ##############################################
        builder.addCase(upsertActionNode.fulfilled, (state, action) => {
            const { node, isDelete } = action.payload;
            state = updateNodesWithPlaceholderAndEdges(state, node, isDelete)
            return state
        })

        //#################################### upsertFinishEmailActionNode ##############################################
        builder.addCase(upsertFinishEmailActionNode.fulfilled, (state, action) => {
            const { node, isDelete } = action.payload;
            state = updateNodesWithPlaceholderAndEdges(state, node, isDelete)
            return state
        })



    },
});

export const automationReducer = automationSlice.reducer;
export const { addPlaceholderNode, clearAutomationState } = automationSlice.actions;
